import { getIndustryData } from "./industry-translations.js";

function initIndustrySelector() {
  const dropdown = document.getElementById("industryDropdown");
  const contentDiv = document.getElementById("industryContent");

  if (!dropdown || !contentDiv) {
    return;
  }

  const renderIndustryContent = (industryKey) => {
    const currentLanguage = document.documentElement.lang || "ro";
    const industryData = getIndustryData(currentLanguage);
    const data = industryData[industryKey];

    if (!data) {
      contentDiv.innerHTML = "";
      return;
    }

    const services = Object.entries(data.services);

    contentDiv.innerHTML = `
      <div class="industry-content">
        <div class="industry-columns">
          <div class="industry-column">
            ${services
              .slice(0, 2)
              .map(
                ([, service]) => `
              <div class="service-section fade-in">
                <h3 class="service-title">${service.title}</h3>
                <p class="service-items">
                  ${service.items.join(". ")}
                </p>
              </div>
            `,
              )
              .join("")}
          </div>
          <div class="industry-column">
            ${services
              .slice(2, 5)
              .map(
                ([, service]) => `
              <div class="service-section fade-in">
                <h3 class="service-title">${service.title}</h3>
                <p class="service-items">
                  ${service.items.join(". ")}
                </p>
              </div>
            `,
              )
              .join("")}
          </div>
        </div>
      </div>
    `;
  };

  renderIndustryContent(dropdown.value);

  dropdown.addEventListener("change", (e) => {
    renderIndustryContent(e.target.value);
  });

  document.addEventListener("languageChanged", () => {
    renderIndustryContent(dropdown.value);
  });
}

document.addEventListener("DOMContentLoaded", initIndustrySelector);

export { initIndustrySelector };
